module.exports = __webpack_public_path__ + "img/ZM.990f7ec8.png";